// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1uyHJ","col":"CardReaderDesc_col__2UxUz","label":"CardReaderDesc_label__6A0Zo"};